import { CANCELLATION_REFUND_TYPE } from '../constants';
import {
  roomFilterOptions,
  roomFilterCategories,
} from '../constants/RoomFilters';
import { AmenityGrouping } from '../constants/AmenityGrouping';

const hasFreeBreakfast = amenities => {
  return amenities.find(amenity => {
    return AmenityGrouping.rate.breakfast.find(id => id == amenity.id);
  });
};
const hasFreeLunch = amenities => {
  return amenities.find(amenity => {
    return AmenityGrouping.rate.lunch.find(id => id == amenity.id);
  });
};
const hasFreeDinner = amenities => {
  return amenities.find(amenity => {
    return AmenityGrouping.rate.dinner.find(id => id == amenity.id);
  });
};
const hasFullBoard = amenities => {
  return (
    amenities.find(amenity => {
      return AmenityGrouping.rate.full_board.find(id => id == amenity.id);
    }) ||
    (hasFreeBreakfast(amenities) &&
      hasFreeLunch(amenities) &&
      hasFreeDinner(amenities))
  );
};
const hasHalfBoard = amenities => {
  return (
    amenities.find(amenity => {
      return AmenityGrouping.rate.half_board.find(id => id == amenity.id);
    }) ||
    (((hasFreeBreakfast(amenities) && hasFreeLunch(amenities)) ||
      (hasFreeLunch(amenities) && hasFreeDinner(amenities)) ||
      (hasFreeDinner(amenities) && hasFreeBreakfast(amenities))) &&
      !hasFullBoard(amenities))
  );
};
const sanitize = value => {
  return value == null || value === undefined ? [] : value;
};
export const getRoomFilterFunctions = (rooms, roomFilter) => {
  //Deep copy - this is to not to mutate the original rooms
  let roomsList = JSON.parse(JSON.stringify(rooms ? rooms : []));
  roomsList = sanitize(roomsList);
  //
  switch (roomFilter) {
    case roomFilterOptions.BREAKFAST_INCLUDED:
      return roomsList
        ? roomsList.filter(room => {
            // mutate the rooms.rates
            if (room.rates !== undefined) {
              room.rates = room.rates.filter(
                rates =>
                  rates.amenities &&
                  (hasFreeBreakfast(rates.amenities) ||
                    (hasFreeBreakfast(rates.amenities) &&
                      hasHalfBoard(rates.amenities))) &&
                  !hasFullBoard(rates.amenities)
              );
            }
            // return all rooms whose rates length is morethan 0
            return room.rates && room.rates.length > 0;
          })
        : [];
    case roomFilterOptions.PAY_AT_THE_HOTEL:
      return roomsList
        ? roomsList.filter(room => {
            if (room.rates !== undefined) {
              room.rates = room.rates.filter(rates => rates.isPayAtHotel);
            }
            return room.rates && room.rates.length > 0;
          })
        : [];
    case roomFilterOptions.BUY_NOW_PAY_LATER:
      return roomsList
        ? roomsList.filter(room => {
            if (room.rates !== undefined) {
              room.rates = room.rates.filter(rates => rates.isPayLater);
            }
            return room.rates && room.rates.length > 0;
          })
        : [];
    case roomFilterOptions.PAY_NOW:
      return roomsList
        ? roomsList.filter(room => {
            if (room?.rates !== undefined) {
              room.rates = room.rates.filter(
                rates => !rates?.isPayAtHotel && !rates?.isPayLater
              );
            }
            return room?.rates && room.rates.length > 0;
          })
        : [];
    case roomFilterOptions.FREE_CANCELLATION:
      return roomsList
        ? roomsList.filter(room => {
            if (room.rates !== undefined) {
              room.rates = room.rates.filter(
                rates =>
                  rates.refundType === CANCELLATION_REFUND_TYPE.FULL_REFUND
              );
            }
            return room.rates && room.rates.length > 0;
          })
        : [];
    case roomFilterOptions.HALF_BOARD:
      return roomsList
        ? roomsList.filter(room => {
            if (room.rates !== undefined) {
              room.rates = room.rates.filter(
                rates => rates.amenities && hasHalfBoard(rates.amenities)
              );
            }
            return room.rates && room.rates.length > 0;
          })
        : [];
    case roomFilterOptions.FULL_BOARD:
      return roomsList
        ? roomsList.filter(room => {
            if (room.rates !== undefined) {
              room.rates = room.rates.filter(
                rates => rates.amenities && hasFullBoard(rates.amenities)
              );
            }
            return room.rates && room.rates.length > 0;
          })
        : [];
    case roomFilterOptions.SINGLE_BED:
      // We are not retuning the rates here but where looking for rooms with such bed info
      return roomsList
        ? roomsList.filter(room => {
            if (room.bedInfo !== undefined) {
              room.bedInfo = room.bedInfo.filter(
                item =>
                  item.configuration &&
                  item.configuration.find(
                    config => config.quantity && config.quantity == 1
                  )
              );
            }
            return room.bedInfo && room.bedInfo.length > 0;
          })
        : [];
    case roomFilterOptions.TWIN_BED:
      return roomsList
        ? roomsList.filter(room => {
            if (room.bedInfo !== undefined) {
              room.bedInfo = room.bedInfo.filter(
                item =>
                  item.configuration &&
                  item.configuration.find(
                    config => config.quantity && config.quantity == 2
                  )
              );
            }
            return room.bedInfo && room.bedInfo.length > 0;
          })
        : [];
    case roomFilterOptions.ROOM_ONLY:
      return roomsList
        ? roomsList.filter(room => {
            if (room.rates !== undefined) {
              room.rates = room.rates.filter(
                rates =>
                  rates.amenities &&
                  !hasFreeBreakfast(rates.amenities) &&
                  !hasFullBoard(rates.amenities) &&
                  !hasHalfBoard(rates.amenities)
              );
            }
            return room.rates && room.rates.length > 0;
          })
        : [];
    default:
      return [];
  }
};
export const getRoomFilterCategory = roomFilter => {
  switch (roomFilter) {
    case roomFilterOptions.BREAKFAST_INCLUDED:
    case roomFilterOptions.HALF_BOARD:
    case roomFilterOptions.FULL_BOARD:
      return roomFilterCategories[0];
    case roomFilterOptions.PAY_AT_THE_HOTEL:
    case roomFilterOptions.BUY_NOW_PAY_LATER:
    case roomFilterOptions.FREE_CANCELLATION:
    case roomFilterOptions.PAY_NOW:
      return roomFilterCategories[1];
    case roomFilterOptions.SINGLE_BED:
    case roomFilterOptions.TWIN_BED:
    case roomFilterOptions.ROOM_ONLY:
      return roomFilterCategories[2];
    default:
      return '';
  }
};
export const getFilteredRooms = (rooms, fileteredSelection) => {
  const sanitized_rooms = sanitize(rooms);
  const sanitized_filter = sanitize(fileteredSelection);
  const filterItems = {};

  sanitized_filter.forEach(item => {
    const key = item.id ? item.id : item.value;
    getRoomFilterFunctions(sanitized_rooms, key).map(item => {
      if (filterItems[item.id] === undefined) {
        filterItems[item.id] = {
          data: [item],
          filtername: [key],
        };
      } else {
        filterItems[item.id].data.push(item);
        filterItems[item.id].filtername.push(key);
      }
    });
  });

  let newrooms = [];
  for (const [key, value] of Object.entries(filterItems)) {
    let rate = [];
    value.data.forEach(room => {
      rate = [...rate, ...room.rates];
    });
    const v = value.data[0];
    v.rates = unique(rate);
    newrooms.push(v);
  }
  return newrooms.length > 0 ? newrooms : sanitized_rooms;
};
const unique = item => {
  var seen = {};
  return item.filter(item => {
    // eslint-disable-next-line no-prototype-builtins
    return seen.hasOwnProperty(JSON.stringify(item))
      ? false
      : (seen[JSON.stringify(item)] = true);
  });
};
